import React, { useRef, useMemo } from 'react'
import JoditEditor from 'jodit-react'
import IFormFieldProps from 'interfaces/form-field-props'
import i18n from 'i18n'
import ErrorField from '../error-field/ErrorField'
import InputLabel from '../input-label/InputLabel'
import './jodit.min.css'
import 'jodit/build/jodit.min.js'

const defaultConfig = {
  language: 'Auto',
  link: {
    noFollowCheckbox: false,
  },
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  toolbarAdaptive: false,
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  disablePlugins: 'placeholder',
  buttons:
    'source,|,bold,underline,strikethrough,italic,|,ul,ol,,outdent,indent,,font,fontsize,brush,|,image,video,table,link,|,align,undo,redo,copyformat',
  height: 150,
  uploader: {
    insertImageAsBase64URI: true,
  },
}

interface IRichText extends IFormFieldProps {
  config?: any
}

const RichTextInput: React.FC<IRichText> = ({
  label,
  value = '',
  config,
  onChange,
  error = '',
  disabled,
}) => {
  const editor = useRef(null)
  // HACK: Text Area loses focus when change the config.
  // https://github.com/jodit/jodit-react/issues/43
  const applyConfig = useMemo(
    () => ({
      ...defaultConfig,
      language: i18n.language,
      ...config,
      disabled: disabled,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disabled]
  )

  return (
    <>
      <InputLabel label={label || ''} />
      <JoditEditor
        ref={editor}
        value={value}
        config={applyConfig}
        onChange={onChange}
        onBlur={() => document.querySelector('.jodit-popup')?.remove()}
      />
      {!!error && <ErrorField text={error} />}
    </>
  )
}

export default RichTextInput
